export default "__VITE_ASSET__ae98cd7a__"